// GENERATED by tools/check-modules.js from modules/*/help.json and apps/web/src/app/help-core.json — do not edit.
export interface HelpEntry { title: string; purpose: string; steps: Array<{ text: string; target?: string }> }
export const HELP: Record<string, HelpEntry> = {
  "/analytics": {
    "title": "Analytics",
    "purpose": "The company on one screen, computed every night: backlog, open receivables, margin against estimate, hit rate, utilization, service; what needs you, ranked; the backlog to burn.",
    "steps": [
      {
        "text": "Tap a tile for its page. The sparkline is the last month."
      },
      {
        "text": "Needs you is the list to work; each opens the screen that fixes it."
      },
      {
        "text": "Read it gives the two-sentence read.",
        "target": "Read it"
      },
      {
        "text": "Compute now recomputes from this minute's records.",
        "target": "Compute now"
      }
    ]
  },
  "/analytics/jobs": {
    "title": "Job health",
    "purpose": "Four dots per job: schedule from plan rows past finish, margin against estimate, billing from cost ahead of billing, safety from the last toolbox talk. Tap for the reasons and the fix.",
    "steps": [
      {
        "text": "Tap a job for why each dot shows what it shows, the figures and the fix."
      },
      {
        "text": "A job needs a budget in Job cost for the margin and billing dots to light."
      }
    ]
  },
  "/analytics/money": {
    "title": "Money",
    "purpose": "Billed and collected by month, awarded by month, receivables by age with the oldest open items, bids by GC.",
    "steps": [
      {
        "text": "Tap an open item to open its application or the service invoices."
      }
    ]
  },
  "/analytics/labor": {
    "title": "Labor",
    "purpose": "Field hours by week with overtime, utilization against forty hours per person punching, billed per hour.",
    "steps": [
      {
        "text": "A grey top on a bar is overtime that week."
      }
    ]
  },
  "/analytics/pack": {
    "title": "Board pack",
    "purpose": "The month's board pack: six figures, the summary, your notes page; a four-page PDF sent to the controller, the accountant and the bank. It drafts itself on the first.",
    "steps": [
      {
        "text": "Pick the month; Draft it if the first has not come yet."
      },
      {
        "text": "Write the notes; Redraft rewrites the summary and keeps them.",
        "target": "Redraft"
      },
      {
        "text": "Approve and send PDF to the list; the pack locks once sent.",
        "target": "Send"
      }
    ]
  },
  "/analytics/pack/:month": {
    "title": "Board pack",
    "purpose": "A month's board pack: the figures frozen on the first, the summary, your notes, the send list.",
    "steps": [
      {
        "text": "Write the notes and send; a sent pack is read-only."
      }
    ]
  },
  "/bids": {
    "title": "Bids",
    "purpose": "Every open bid by stage, what is due soon, what is submitted and waiting, and the hit rate over twelve months. A bid moves Identification → Pricing → Review → Submitted, then ends Won, Lost or back to Pricing for a rebid.",
    "steps": [
      {
        "text": "On the desktop the page opens on Bidding now: the bids being priced, the next four weeks above them, then the list by due date with the days left and what each bid is still missing (a due date, an estimator, a GC, the plans link, a number, the proposal, the send). Submitted sits folded below it in three age groups; its tile opens the full list, where With the GC is the GC's own state (Bid sent, Confirmed, Rebid) or the follow-up that is due, with Send now on the row, and after 90 days with no answer a bid asks for Mark lost or Still live. Every row leads with the job's name, the number small beside it."
      },
      {
        "text": "On a desktop row, the menu moves the bid to another stage or marks it lost."
      },
      {
        "text": "Due soon is the list to work today."
      },
      {
        "text": "New bid starts one the day the invitation lands.",
        "target": "New bid"
      }
    ]
  },
  "/bids/new": {
    "title": "New bid",
    "purpose": "The job, when it is due, the working value, who estimates it and who sells it, the flags, the plans link, what the GC said.",
    "steps": [
      {
        "text": "Name it the way the folder is named; set the due date and time."
      },
      {
        "text": "Pick the estimator and the sales rep; tick prevailing wage, union or the certifications it needs."
      },
      {
        "text": "Start the bid; then add the GCs bidding it.",
        "target": "Start the bid"
      }
    ]
  },
  "/bids/:id": {
    "title": "A bid",
    "purpose": "The bid's stage, the job, the bid plan, the GCs, the quotes, the proposal and the documents. Tap a stage to move it.",
    "steps": [
      {
        "text": "Move the stage as the bid moves; Submitted starts the GC follow-ups."
      },
      {
        "text": "The bid plan is the estimating checklist; Build it from Plan the first time."
      },
      {
        "text": "GCs, Quotes and Proposal are the work; Mark lost closes it with the reason."
      }
    ]
  },
  "/bids/:id/gcs": {
    "title": "GC bidders",
    "purpose": "The GCs who invited us on this job, from our seat: Invited us, Bid sent, Confirmed, Rebid, then Awarded, Lost or Declined. Bid sent sets itself when the proposal goes to that GC and their number is logged under them. The follow-ups run after Bid sent on the office schedule.",
    "steps": [
      {
        "text": "Add each GC that sent an invitation, from the library or by name, with an email.",
        "target": "Add GC"
      },
      {
        "text": "Send the bid opens the Proposal page; each GC gets their own PDF and sign link.",
        "target": "Send the bid"
      },
      {
        "text": "Set the winner to Awarded, or let their signature do it; the others close as Lost and the plan opens.",
        "target": "Awarded"
      }
    ]
  },
  "/bids/:id/quotes": {
    "title": "Vendor quotes",
    "purpose": "The quotes behind the price, by package: ask, remind, mark in, carry the one the price rests on. On award they hand to Procurement.",
    "steps": [
      {
        "text": "Ask a vendor per package; two or three each.",
        "target": "Ask a vendor"
      },
      {
        "text": "Mark each quote In with the amount; Low is shown."
      },
      {
        "text": "Carry the one you are pricing on; it ticks the bid plan's quote row.",
        "target": "Carry"
      }
    ]
  },
  "/bids/:id/proposal": {
    "title": "Proposal",
    "purpose": "One proposal in the company's own layout: scope, clarifications, exclusions, alternates, unit prices, the base bid and the terms, started from the standard text under Settings → Company. Signed by you. Sent to each GC at their own price with your files and links, one email each, logged on the bid's Mail. The GC's signature awards the bid.",
    "steps": [
      {
        "text": "A line or two of takeoff notes, then Draft the scope; read every line. Fill the drawings line.",
        "target": "Draft the scope"
      },
      {
        "text": "Set the base bid, the alternates, the unit prices and the terms. Save."
      },
      {
        "text": "Sign on the pad, then Send the bid: tick the GCs, give any of them their own price, attach the package from the bid or your device, add links, send.",
        "target": "Send the bid"
      }
    ]
  },
  "/bids/:id/lost": {
    "title": "Mark lost",
    "purpose": "Close a bid with why, the winning number if you know it, and notes, so the hit rate says something.",
    "steps": [
      {
        "text": "Pick the reason; enter the winning number if the GC told you."
      },
      {
        "text": "Mark lost.",
        "target": "Mark lost"
      }
    ]
  },
  "/billing": {
    "title": "Billing",
    "purpose": "The job's billing: billed to date, retainage held, what is open, the cutoff, every payment application with its state, the lien waivers.",
    "steps": [
      {
        "text": "Pick the job. The schedule of values must be set before the first application.",
        "target": "Schedule of values"
      },
      {
        "text": "New application starts the period from the last one; the field can mark the period with sliders."
      },
      {
        "text": "Receivables shows every open application across the jobs by age.",
        "target": "Receivables"
      }
    ]
  },
  "/billing/sov": {
    "title": "Schedule of values",
    "purpose": "The lines the job is billed on, their values, the approved change orders as their own lines, and the retainage rates. It should match the contract.",
    "steps": [
      {
        "text": "Type the lines with their values; the total is checked against the project's contract."
      },
      {
        "text": "An approved change order goes on as its own line by itself the moment it is approved; a credit goes on negative. The × takes one off."
      },
      {
        "text": "Set retainage on work and on stored material. Save.",
        "target": "Save"
      }
    ]
  },
  "/billing/app/new": {
    "title": "New application",
    "purpose": "The next payment application, numbered, with the period and the prior figures carried from the last one. Everything billed before, stored material included, is in previous.",
    "steps": [
      {
        "text": "Check the period dates and the number."
      },
      {
        "text": "Start it; then enter this period line by line.",
        "target": "Start"
      }
    ]
  },
  "/billing/app/:id": {
    "title": "An application",
    "purpose": "The application through Draft, Signed, Sent, Approved, Paid: the nine lines, the change order summary, this period per line, the signature, the PDF, the send, the payments.",
    "steps": [
      {
        "text": "Enter this period per line, or let the super mark it with sliders from the phone. Stored material is billed the month you enter it and rolls into previous on the next application."
      },
      {
        "text": "A credit change order is taken in full on the first application after it is approved; it shows under deductions in the change order summary."
      },
      {
        "text": "Sign on the pad; make the PDF; Send to GC with a waiver attached if they want one.",
        "target": "Send to GC"
      },
      {
        "text": "Approved with the amount when the GC answers; Record payment until it is paid.",
        "target": "Record payment"
      },
      {
        "text": "Void is the office's undo; nothing is deleted."
      }
    ]
  },
  "/billing/app/:id/period": {
    "title": "Mark this period",
    "purpose": "The field's view of the draft application: each line as a slider for how far along it is. Send to the office; the office signs and sends.",
    "steps": [
      {
        "text": "Drag each line to how far along the work is."
      },
      {
        "text": "Send to the office.",
        "target": "Send to the office"
      }
    ]
  },
  "/billing/waiver/new": {
    "title": "New lien waiver",
    "purpose": "A waiver drafted from an application: conditional or unconditional, progress or final, with the through date and the amount.",
    "steps": [
      {
        "text": "Pick the kind and the application it covers."
      },
      {
        "text": "Start it; sign it on its page or send the signing link.",
        "target": "Start"
      }
    ]
  },
  "/billing/waiver/:id": {
    "title": "A lien waiver",
    "purpose": "The waiver with its figures, signed on the pad or by a signing link, as a PDF for the GC's package.",
    "steps": [
      {
        "text": "Sign on the pad, or Send a signing link.",
        "target": "Sign"
      },
      {
        "text": "PDF to attach to the application.",
        "target": "PDF"
      }
    ]
  },
  "/billing/ar": {
    "title": "Receivables",
    "purpose": "Every open application across the jobs by age, what needs a call, chase now, the payments, and a statement per customer.",
    "steps": [
      {
        "text": "The age bands show what is current and what is past due."
      },
      {
        "text": "Chase now sends the reminder today; the schedule sends them by itself on days 33, 44 and 60.",
        "target": "Chase now"
      },
      {
        "text": "Record payment when the money lands. Statement makes one per customer.",
        "target": "Record payment"
      }
    ]
  },
  "/channel": {
    "title": "The job channel",
    "purpose": "One feed per job for anything the whole job should see. A photo and a sentence is enough; the office sees the same feed, and nobody can say they never saw it.",
    "steps": [
      {
        "text": "Type at the bottom; add a photo; send.",
        "target": "Send"
      },
      {
        "text": "Type @ and pick a name to buzz their phone. One push per thread per hour, never more."
      },
      {
        "text": "Pinned stays on top: the foreman or office pins a gate code or an inspection time."
      },
      {
        "text": "Tap a message to open its thread. Under your message you see who has read it."
      }
    ]
  },
  "/channel/t/:id": {
    "title": "A thread",
    "purpose": "The replies to one message. When the GC needs to answer, the foreman or office turns the thread into an RFI with the photos and the discussion attached.",
    "steps": [
      {
        "text": "Reply in thread keeps it together.",
        "target": "Reply"
      },
      {
        "text": "Create RFI from this thread lands it in RFIs & changes, ready to send to the GC.",
        "target": "Create RFI"
      },
      {
        "text": "Log as a delay puts it on today's daily report.",
        "target": "Log as a delay"
      },
      {
        "text": "Nothing is edited. Remove your own message if you must; it leaves a mark."
      }
    ]
  },
  "/controls": {
    "title": "Controls",
    "purpose": "RFIs, submittals, change orders and addenda on the job: the counts, what waits on the GC, what waits on us, and how fast answers come.",
    "steps": [
      {
        "text": "Pick the job. The four counts open each log."
      },
      {
        "text": "Waiting on the GC is what you chase; Waiting on us is what the crew or the office owes."
      },
      {
        "text": "Follow-ups to the GC run on the office schedule by themselves; pause one on its page if the GC asked for time."
      }
    ]
  },
  "/controls/rfis": {
    "title": "RFIs",
    "purpose": "Every question asked of the GC on the job, open or all, with the dates and who owes the answer.",
    "steps": [
      {
        "text": "Open shows what is waiting; All shows the history."
      },
      {
        "text": "A late due date shows red. Tap one to send, follow up, or record the answer."
      },
      {
        "text": "New RFI starts one; a drawing pin or a channel thread can start one too.",
        "target": "New RFI"
      }
    ]
  },
  "/controls/rfis/new": {
    "title": "New RFI",
    "purpose": "Ask the GC a question with the drawing, the photos and the date you need the answer by.",
    "steps": [
      {
        "text": "Say the question plainly; attach the sheet or the photos."
      },
      {
        "text": "Set the date you need it by."
      },
      {
        "text": "Send to the GC. The follow-ups run from today on the office schedule.",
        "target": "Send"
      }
    ]
  },
  "/controls/rfis/:id": {
    "title": "An RFI",
    "purpose": "The question, its steps, the follow-up schedule and the answer. Record the answer here and the crew's phone has it the same minute.",
    "steps": [
      {
        "text": "Send to the GC if it has not gone yet."
      },
      {
        "text": "When the answer comes, Record the answer, with the date and the text.",
        "target": "Record the answer"
      },
      {
        "text": "Close it when it is settled; Reopen if the answer did not hold.",
        "target": "Close"
      },
      {
        "text": "Pause follow-ups if the GC asked for time.",
        "target": "Pause"
      }
    ]
  },
  "/controls/submittals": {
    "title": "Submittals",
    "purpose": "What has to be approved before it is bought: each submittal with its revision, its dates and the lead time against the plan.",
    "steps": [
      {
        "text": "A submittal with an approve-by date past the plan's need shows a warning."
      },
      {
        "text": "Tap one to submit, revise, approve or reject."
      },
      {
        "text": "New submittal starts one.",
        "target": "New submittal"
      }
    ]
  },
  "/controls/submittals/new": {
    "title": "New submittal",
    "purpose": "A submittal with the item, the spec section, the lead time and the date it must be approved by to make the plan.",
    "steps": [
      {
        "text": "Name the item and the spec section; set the lead time in weeks."
      },
      {
        "text": "The approve-by date is worked out from the plan's need date."
      },
      {
        "text": "Save, then send to the GC from its page.",
        "target": "Save"
      }
    ]
  },
  "/controls/submittals/:id": {
    "title": "A submittal",
    "purpose": "The submittal's revisions, each with its dates, and the GC's answer. Revise keeps the history as Rev 1, Rev 2.",
    "steps": [
      {
        "text": "Send to the GC with the package attached.",
        "target": "Send"
      },
      {
        "text": "Record the GC's answer: Approved, Approved as noted, Revise and resubmit, Rejected."
      },
      {
        "text": "Revise starts the next revision with the old one kept.",
        "target": "Revise"
      }
    ]
  },
  "/controls/cos": {
    "title": "Change orders",
    "purpose": "Extra work on the job: lump sum or time and material, pending or approved, with what each one does to the contract.",
    "steps": [
      {
        "text": "Pending is money waiting on the GC; an old pending one shows its age."
      },
      {
        "text": "Tap one to request approval, log a day on a T&M order, or approve it."
      },
      {
        "text": "New change order starts one.",
        "target": "New change order"
      }
    ]
  },
  "/controls/cos/new": {
    "title": "New change order",
    "purpose": "Extra work priced as a lump sum, or as time and material with hourly rates by trade, a material markup and a not-to-exceed.",
    "steps": [
      {
        "text": "Describe the change and why."
      },
      {
        "text": "Lump sum: Extra with the price, or Credit with the amount coming off for descoped work. T&M: the rates by trade, the markup, the cap."
      },
      {
        "text": "Once approved it goes on the job's schedule of values as its own line by itself and is billed from there."
      },
      {
        "text": "Save, then Request approval from its page.",
        "target": "Save"
      }
    ]
  },
  "/controls/cos/:id": {
    "title": "A change order",
    "purpose": "The change order's status, its effect on the contract, and for a T&M order the daily logs the field files with the GC's signature.",
    "steps": [
      {
        "text": "Request approval opens the Send sheet: the GC's project manager is picked, the price and reason go in the email, attach the proposal or anything from the job, Send.",
        "target": "Request approval"
      },
      {
        "text": "Approve or reject when the GC answers; approved adds to the contract and the billing schedule.",
        "target": "Approve"
      },
      {
        "text": "On a T&M order, Add today starts the day's log for the field.",
        "target": "Add today"
      }
    ]
  },
  "/controls/cos/:coId/log": {
    "title": "Today's T&M log",
    "purpose": "One log per day on a time-and-material change order: who was on it from the clock, the material, the equipment, what was done, the GC rep's signature.",
    "steps": [
      {
        "text": "The people and hours come from the clock; fix them if someone was elsewhere."
      },
      {
        "text": "Add the material and the equipment used."
      },
      {
        "text": "Hand the phone to the GC's rep to sign before they leave.",
        "target": "Sign"
      },
      {
        "text": "File today's log. One per day.",
        "target": "File"
      }
    ]
  },
  "/controls/cos/:coId/log/:id": {
    "title": "A T&M log",
    "purpose": "A filed day on a time-and-material change order: the labor, the material, the equipment, the signature, priced at the order's rates for the office.",
    "steps": [
      {
        "text": "Read it; a filed log is not edited. A wrong one is voided by the office and refiled."
      },
      {
        "text": "Send to GC opens the Send sheet: the question and the dates go in the email, the sheet the pin sits on and the thread's photos are attached, add anything else from the job, Send. PDF prints it.",
        "target": "Send to GC"
      }
    ]
  },
  "/controls/addenda": {
    "title": "Addenda",
    "purpose": "The addenda on the bid or the job, numbered, with whether each was acknowledged in the bid and whether it is in the current set.",
    "steps": [
      {
        "text": "Log an addendum when it lands with its number and date.",
        "target": "Log"
      },
      {
        "text": "Tick Acknowledged in bid when the bid carried it."
      }
    ]
  },
  "/costing": {
    "title": "Job cost",
    "purpose": "The job's money in one place, computed every night: projected margin against the estimate, budget, committed, actual and projected, cost against billing, where the projection moved and why.",
    "steps": [
      {
        "text": "Pick the job. It needs a budget first.",
        "target": "Budget"
      },
      {
        "text": "The four bars: budget, committed on orders, actual from bills and the clock, projected."
      },
      {
        "text": "Labor is where a job goes wrong first; open it.",
        "target": "Labor"
      },
      {
        "text": "Update projections recomputes now; Explain gives two sentences on why a number moved.",
        "target": "Explain"
      }
    ]
  },
  "/costing/labor": {
    "title": "Labor",
    "purpose": "Hours by plan phase against the estimate, by person at their loaded rate, by week. The phase running past its pace is named.",
    "steps": [
      {
        "text": "By phase: hours land on the phases active by the plan's dates, so keep the plan's dates real."
      },
      {
        "text": "By person shows the loaded rate; by week shows the pace and overtime."
      }
    ]
  },
  "/costing/code/:bucket": {
    "title": "A cost bucket",
    "purpose": "One bucket, materials, equipment, subs or other: the orders with billed against ordered, the bills, installed against billed.",
    "steps": [
      {
        "text": "An order billed beyond what was received shows the hold."
      },
      {
        "text": "Bought out on the budget tells the projection to trust the orders from now on."
      }
    ]
  },
  "/costing/budget": {
    "title": "Budget",
    "purpose": "The five cost buckets the job was estimated at and the hours per plan phase. Everything in Job cost measures against this.",
    "steps": [
      {
        "text": "Enter labor, materials, equipment, subcontractors and other, and the estimated hours per phase."
      },
      {
        "text": "Tick Bought out on a bucket once every order for it is placed."
      },
      {
        "text": "Save; the roll-up runs on save.",
        "target": "Save"
      }
    ]
  },
  "/costing/rates": {
    "title": "Rates",
    "purpose": "The wage schedules that price punched hours: standard, prevailing wage, union; burden; a base rate per person; which schedule this job pays.",
    "steps": [
      {
        "text": "Pick the schedule the job pays at the top."
      },
      {
        "text": "Set burden once and a base rate per person; a person without one falls to the schedule's default."
      },
      {
        "text": "Save. Owner or admin only.",
        "target": "Save"
      }
    ]
  },
  "/drawings": {
    "title": "Drawings",
    "purpose": "The set on the phone, grouped by sheet number; the latest revision opens. The office's pins and markups are on it.",
    "steps": [
      {
        "text": "Tap a sheet. A yellow bar means an old revision; tap through to the current one and build from that."
      },
      {
        "text": "Add sheet: the PDF from your files or a photo of the paper sheet, with the number and revision. Everyone on the job gets a push.",
        "target": "Add sheet"
      }
    ]
  },
  "/drawings/add": {
    "title": "Add a sheet",
    "purpose": "A new sheet or revision from the GC: the PDF, or a photo of the paper, with the sheet number and the revision.",
    "steps": [
      {
        "text": "Pick the file or take the photo."
      },
      {
        "text": "Sheet number and revision; the same number as an existing sheet makes it the new revision."
      },
      {
        "text": "Save. The crew is told a new revision landed.",
        "target": "Save"
      }
    ]
  },
  "/drawings/:id": {
    "title": "A sheet",
    "purpose": "Pinch to zoom, drag to pan, page through a PDF. Drop a pin where you stand to leave a note, a photo, a punch item or an RFI. The toolbar has the whole markup kit and measure.",
    "steps": [
      {
        "text": "Drop a pin, tap the spot, a note if you want, Save pin. Then Add a photo, Punch item here, or RFI here.",
        "target": "Drop a pin"
      },
      {
        "text": "Markup: pick a tool (box, cloud, arrow, highlighter, text), pick a colour, drag. Tap a markup to move or delete it."
      },
      {
        "text": "Measure: pick the sheet's scale from the list, then drag between two points. The dimension stays on the sheet.",
        "target": "Measure"
      },
      {
        "text": "The three dots: Download as-built, the sheet with every markup as a PDF."
      }
    ]
  },
  "/reports": {
    "title": "Reports",
    "purpose": "The daily report and the weekly report. Today assembles itself from the clock, the plan, the photos, the weather, deliveries and safety; the foreman reads it, signs and files it before the truck leaves.",
    "steps": [
      {
        "text": "Tap Today to open or continue today's report.",
        "target": "Today"
      },
      {
        "text": "Photos as you work: tap a tag first (the plan row, Issue, Delivery, Inspection, Progress), then Take photo. The tag becomes the caption."
      },
      {
        "text": "Weekly is Friday's: it builds from the week's dailies.",
        "target": "Weekly"
      }
    ]
  },
  "/reports/new": {
    "title": "Today's report",
    "purpose": "The crew, hours, photos, weather, deliveries, visitors and safety are already filled in. You add the work performed, the delays and issues, then sign and file. The GC has it before you leave the lot.",
    "steps": [
      {
        "text": "Draft from today writes the work performed from the day's facts. Read it, fix what it got wrong.",
        "target": "Draft from today"
      },
      {
        "text": "Delays and issues go in the moment they happen, while it is fresh."
      },
      {
        "text": "Check who it goes to, sign, File. The phone reminds you at 3:30 if it is not filed.",
        "target": "File"
      }
    ]
  },
  "/reports/week": {
    "title": "Weekly report",
    "purpose": "Friday's report to the GC: hours, crew-days, plan movement, photos, deliveries, safety, RFIs, change orders, punch, assembled from the week's dailies.",
    "steps": [
      {
        "text": "Draft from the week writes the summary; read it and fix anything.",
        "target": "Draft from the week"
      },
      {
        "text": "Add what the GC needs to know for next week, sign, send. The phone reminds the foreman and PM at 2:30 Friday."
      }
    ]
  },
  "/reports/week/:id": {
    "title": "A weekly report",
    "purpose": "A filed weekly report: PDF, Send to GC, or voided by the office with a reason.",
    "steps": [
      {
        "text": "PDF prints it; Send to GC emails it from the PM's address.",
        "target": "Send to GC"
      }
    ]
  },
  "/reports/:id": {
    "title": "A daily report",
    "purpose": "A filed daily report with its photos. It stays on the job forever; the office can void one with a reason, never delete it.",
    "steps": [
      {
        "text": "PDF prints it with the photos.",
        "target": "PDF"
      },
      {
        "text": "Send to GC emails it and logs it on the job's Mail.",
        "target": "Send to GC"
      }
    ]
  },
  "/records": {
    "title": "Records",
    "purpose": "The sign-in sheet, the toolbox talk and the code meeting for this job, filed with every signature and the time it was signed. The office sees them the minute they are filed.",
    "steps": [
      {
        "text": "The orange plus starts one: Sign-in sheet, Toolbox talk, or Electrical code meeting.",
        "target": "+"
      },
      {
        "text": "Today's open sheet resumes from here; a draft shows Continue and Discard."
      },
      {
        "text": "Export builds the binder for a GC or OSHA request.",
        "target": "Export"
      }
    ]
  },
  "/records/new/:type": {
    "title": "New record",
    "purpose": "A record is built on the phone and signed by the people on it. It files when you tap File; until then it is a draft that stays on this phone.",
    "steps": [
      {
        "text": "Sign-in sheet: everyone who clocked in is already listed. Hand the phone around; each person taps Sign in when they arrive and Sign out when they leave.",
        "target": "Sign in"
      },
      {
        "text": "Toolbox talk: take the suggested topic or pick one, say a few words, note hazards and controls, pass the phone so the crew signs.",
        "target": "Sign"
      },
      {
        "text": "Code meeting: the code section, what it requires, how it applies here; everyone signs that they understood."
      },
      {
        "text": "Tap File when it is complete. A sign-in sheet closes at the end of the day with Close sheet for today.",
        "target": "File"
      }
    ]
  },
  "/records/export": {
    "title": "Export",
    "purpose": "The binder: every record on the job between two dates, as one PDF for a GC or an OSHA request.",
    "steps": [
      {
        "text": "Pick the dates and the record types."
      },
      {
        "text": "Tap Build. The PDF files to the job and downloads here.",
        "target": "Build"
      }
    ]
  },
  "/records/topics": {
    "title": "Topic library",
    "purpose": "The toolbox talk topics the app suggests, and the trade the code meetings are written for.",
    "steps": [
      {
        "text": "A topic not yet given on this job is suggested first."
      },
      {
        "text": "Owner or admin: set the trade here; the code meeting takes its name from it."
      }
    ]
  },
  "/records/:id": {
    "title": "A record",
    "purpose": "A filed record is never deleted. It can be sent to the GC, printed as a PDF, or voided by the office with a reason.",
    "steps": [
      {
        "text": "PDF prints it with every signature.",
        "target": "PDF"
      },
      {
        "text": "Send to GC emails it from the PM's address and logs it on the job's Mail.",
        "target": "Send to GC"
      },
      {
        "text": "A draft shows Continue and Discard instead."
      }
    ]
  },
  "/mail": {
    "title": "The job's mail",
    "purpose": "Every email in and out on this job, in one log. The job has its own address; anything sent to it files itself with the attachments.",
    "steps": [
      {
        "text": "Pick the job. Copy the job's address and give it to the GC and the vendors.",
        "target": "Copy"
      },
      {
        "text": "Filter: All, In, Out, GC, Vendors, Formal. Search by a word."
      },
      {
        "text": "Tap a message to read it, reply, or record an RFI answer from it."
      },
      {
        "text": "Unfiled is the mail the app could not place on a job; file it or discard it.",
        "target": "Unfiled"
      }
    ]
  },
  "/mail/unfiled": {
    "title": "Unfiled mail",
    "purpose": "Email that reached the company but named no job. The app guesses the job from the address, the GC's email, the subject or a vendor; you confirm.",
    "steps": [
      {
        "text": "Read the guess under each message. Pick a different job if it is wrong."
      },
      {
        "text": "File it: it moves onto the job with its attachments.",
        "target": "File it"
      },
      {
        "text": "Discard what is not about any job.",
        "target": "Discard"
      }
    ]
  },
  "/mail/new": {
    "title": "New message",
    "purpose": "Send an email from the app on this job, or log one you already sent or received elsewhere so the record is complete.",
    "steps": [
      {
        "text": "Send: pick who from Contacts (the job's GC project manager, the GC and vendor lists) or type an email; say what it is about (the job's name goes in front by itself); the note; attach files from the job (Files, Drawings, Photos, Records) or from this device. It goes from your address with the job's address on copy so the reply files itself, and the files are kept on the log."
      },
      {
        "text": "Log by hand: direction, who, when, what. Nothing is sent."
      },
      {
        "text": "Send, or Log it.",
        "target": "Send"
      }
    ]
  },
  "/mail/:id": {
    "title": "A message",
    "purpose": "The message with its attachments. Reply from here and the reply is logged; an email that names an RFI can be recorded as the answer.",
    "steps": [
      {
        "text": "Open an attachment to read it."
      },
      {
        "text": "Reply: the original is quoted, the job's address rides on copy, the office gets a bell.",
        "target": "Reply"
      },
      {
        "text": "Draft asks the assistant for a first reply you then fix.",
        "target": "Draft"
      },
      {
        "text": "If the subject names an open RFI, Record as the answer opens the RFI with the answer filled in.",
        "target": "Record as the answer"
      }
    ]
  },
  "/materials": {
    "title": "Materials",
    "purpose": "Ask for material and tools from the ladder, see how each line is coming, receive what the truck brings, and see what the job has on site.",
    "steps": [
      {
        "text": "Requests: New request for material; the Tools tab for a tool from the shop.",
        "target": "New request"
      },
      {
        "text": "On the pickup shelf and Coming on the truck show at the top when the shop has something for you. Tap Got it when you have it.",
        "target": "Got it"
      },
      {
        "text": "Deliveries: receive against the PO when the truck comes; count, flag shorts, photograph damage, sign.",
        "target": "Deliveries"
      },
      {
        "text": "On site is what the job has, built from the receipts.",
        "target": "On site"
      }
    ]
  },
  "/materials/request": {
    "title": "New request",
    "purpose": "Say what you need with quantities, and per line whether it comes from the shop, gets ordered, or either. The office plans each line, names a runner for what the shop and the counter supply, and your phone gets one push with the plan.",
    "steps": [
      {
        "text": "Type each line with a quantity; \"40 ft 3/4 EMT\" works. A green chip means the shop has it; tapping it only names the shop item.",
        "target": "Add"
      },
      {
        "text": "Don't know the whole list? Say what you are doing and tap Draft the list; read it before you send.",
        "target": "Draft the list"
      },
      {
        "text": "Needed by, and where on the job to deliver."
      },
      {
        "text": "How it gets to you: Needs to come to us, or Someone can pick up at the shop with the day. That is an offer; the office decides each line.",
        "target": "Someone can pick up"
      },
      {
        "text": "Send to office.",
        "target": "Send to office"
      },
      {
        "text": "Comes from: Shop when the shop has it and it fits the plan, Order when you want it bought even if the shop has some, Either to let the office decide. The office can still change a line and you see why."
      }
    ]
  },
  "/materials/req/:id": {
    "title": "A request",
    "purpose": "The whole order on one page: each line says where it comes from (Shop, Order, Either as you asked; the office may change it), where it is now, and who touched it. The strip at the top walks Requested, Planned, Pulled, Ordered, Picked up, At the job, On site, Done.",
    "steps": [
      {
        "text": "A line pulled at the shop or picked up at the counter shows Got it once it is at the job; tap it and it lands on On site.",
        "target": "Got it"
      },
      {
        "text": "If you are the runner, Pulled and Picked up are yours per line; Delivered to the job tells the foreman everything you carried is there.",
        "target": "Delivered to the job"
      },
      {
        "text": "Shipping from the warehouse without a runner means confirm it under Deliveries when it lands."
      },
      {
        "text": "The request closes itself when every line is on site. Cancel request only while nothing has been ordered or pulled.",
        "target": "Cancel request"
      }
    ]
  },
  "/materials/tools/new": {
    "title": "Tool request",
    "purpose": "A tool from the shop: the shop's list pops up as you type with where each tool is. The office plans it like material: the shelf, or the truck.",
    "steps": [
      {
        "text": "Name the tool; pick it from the chips if the shop has it.",
        "target": "Tap to name"
      },
      {
        "text": "Needed by, how urgent, a note for the warehouse."
      },
      {
        "text": "Say whether someone can pick it up at the shop, then Send to the office.",
        "target": "Send to the office"
      }
    ]
  },
  "/materials/tool/:id": {
    "title": "A tool request",
    "purpose": "Where the tool stands: requested, picked up by the warehouse, on the shelf or the truck, on the job. The office checks it out to the job in the end.",
    "steps": [
      {
        "text": "Got it when you take it off the shelf.",
        "target": "Got it"
      },
      {
        "text": "Withdraw this request only while nobody has picked it up.",
        "target": "Withdraw"
      }
    ]
  },
  "/materials/run/:id": {
    "title": "A run",
    "purpose": "The truck's day: the pick list by job, the stops, and what comes back. The driver works it from the phone; the office closes it when the truck is back.",
    "steps": [
      {
        "text": "At the shop: tap Load as each line goes on the truck; Short if the shop does not have it.",
        "target": "Load"
      },
      {
        "text": "Truck's out when you leave. The jobs are told.",
        "target": "Truck's out"
      },
      {
        "text": "At each stop tap Delivered; the lines land on that job's On site list.",
        "target": "Delivered"
      },
      {
        "text": "Coming back: tap the tools checked out to that job, or add anything else with a quantity."
      },
      {
        "text": "Back at the shop the office taps Close run: tools are checked in, shorts go back to the office to buy."
      }
    ]
  },
  "/materials/receive/:poId?": {
    "title": "Receive",
    "purpose": "What you sign for is what the office matches the vendor's bill against. Count carefully and mark the shorts.",
    "steps": [
      {
        "text": "Every line starts as all here. Tap a line that is short or missing and count it, or tap Not on the truck.",
        "target": "Not on the truck"
      },
      {
        "text": "Damaged: tap it and photograph it.",
        "target": "Damaged"
      },
      {
        "text": "Note the ticket number and where it is staged, sign. The office sees the receipt the same minute.",
        "target": "Sign"
      }
    ]
  },
  "/materials/delivery/:id": {
    "title": "A receipt",
    "purpose": "A signed delivery receipt: the lines as counted, shorts and damage flagged, the photos, who signed.",
    "steps": [
      {
        "text": "Shorts stay open as a backorder on the order; the office chases them."
      }
    ]
  },
  "/plan": {
    "title": "The plan",
    "purpose": "Every job's schedule: the phases, the rows, the dates, what is late and what is on the critical path. The crew reports progress from the phone; the desktop draws the Gantt.",
    "steps": [
      {
        "text": "Pick the job at the top. Jobs come first, then the open bids; a bid carries the bid plan."
      },
      {
        "text": "On the phone: the summary, then the phases with their rows. Filters: All, My rows, This week, Flagged, Late."
      },
      {
        "text": "Tap a row to see where it stands and report progress."
      },
      {
        "text": "On the desktop: click a row and its fields are on the strip pinned above the chart; drag a bar to move it, pull its end to resize; More opens the note, move, indent, insert and remove.",
        "target": "More"
      },
      {
        "text": "Tick rows (shift-click for a range, or tick a phase for its whole group) and the strip changes many at once: owner, done %, move by workdays, flag, done. Apply, then Save and reschedule.",
        "target": "Save and reschedule"
      },
      {
        "text": "No plan yet? Build it starts one from the standard build-out, the assistant, the bid plan, a template or empty.",
        "target": "Build it"
      }
    ]
  },
  "/plan/pick": {
    "title": "Build the plan",
    "purpose": "Start a plan, or replace one: the full commercial build-out with the scope modules you tick, the assistant reading your scope, the bid plan for a bid, a saved template, or empty.",
    "steps": [
      {
        "text": "Pick where to start from. A bid defaults to the bid plan; a job to the full build-out."
      },
      {
        "text": "Tick the scope modules the job has, or paste the scope and let the assistant tick them.",
        "target": "Read the scope"
      },
      {
        "text": "A start date pins the first rows; leave it blank to schedule from today."
      },
      {
        "text": "Build plan, or Replace plan when one exists. Add scope inserts modules into a plan you keep.",
        "target": "Build plan"
      }
    ]
  },
  "/plan/project": {
    "title": "The project",
    "purpose": "The job's overview: the GC's project manager and email, the stage, the dates, who runs it, the links, the contract value and the billing cutoff.",
    "steps": [
      {
        "text": "Set the GC project manager's name and email here; every send to the GC uses them."
      },
      {
        "text": "Keep the start and target end honest; the plan and the look-ahead read them."
      },
      {
        "text": "Save.",
        "target": "Save"
      }
    ]
  },
  "/plan/task/:id": {
    "title": "A row",
    "purpose": "One row of the plan: where it stands, its dates and slack, what it waits on and what it blocks, and the progress you report.",
    "steps": [
      {
        "text": "Drag the slider to how far along it is, or tap a quick pill."
      },
      {
        "text": "Add a note or a photo tagged to the row."
      },
      {
        "text": "Save progress. Mark done when it is finished; the office and the crew see it the same minute.",
        "target": "Save progress"
      }
    ]
  },
  "/procurement": {
    "title": "Procurement",
    "purpose": "What the jobs need bought and how it is coming: the field's requests to plan, the open orders by stage, the quotes waiting, this week's deliveries.",
    "steps": [
      {
        "text": "From the field lists material and tool requests nobody has planned. Plan it decides each line.",
        "target": "Plan it"
      },
      {
        "text": "Open orders by stage: draft, signed, sent, acknowledged, received, billed."
      },
      {
        "text": "Runs, Shelf and Shop are the shop's side of the plan.",
        "target": "Shelf"
      }
    ]
  },
  "/procurement/orders": {
    "title": "Orders",
    "purpose": "Every purchase order on the job with its stage and what the field has received against it.",
    "steps": [
      {
        "text": "Tap an order to sign, send, acknowledge or match a bill."
      },
      {
        "text": "New order starts one blank, from a request, or from a quote.",
        "target": "New order"
      }
    ]
  },
  "/procurement/orders/new": {
    "title": "New order",
    "purpose": "A purchase order to a vendor: the lines with quantity, unit, cost and cost code, the need-by date, where it ships. From a request the lines are already there.",
    "steps": [
      {
        "text": "Pick the vendor from the library; the email goes to its address."
      },
      {
        "text": "Check each line's quantity, cost and cost code. Will-call ticks the branch the crew picks up at."
      },
      {
        "text": "Save the order; sign and send it from its page.",
        "target": "Save"
      }
    ]
  },
  "/procurement/orders/:id": {
    "title": "An order",
    "purpose": "The order through its stages: sign it in the app or send a signing link, send it to the vendor, mark it acknowledged and shipped, watch the field's receipts land, match the bills.",
    "steps": [
      {
        "text": "Sign on the pad, or Send a signing link for someone else.",
        "target": "Sign"
      },
      {
        "text": "Send to the vendor from the library email.",
        "target": "Send"
      },
      {
        "text": "Acknowledged when the vendor confirms; the field's receipts fill the received column by themselves."
      },
      {
        "text": "Match the bill when it arrives.",
        "target": "Match the bill"
      }
    ]
  },
  "/procurement/orders/:id/bill": {
    "title": "Match a bill",
    "purpose": "The vendor's bill against the order and what was received, line by line. A line billed beyond the receipt is held at its cost; the rest is approved.",
    "steps": [
      {
        "text": "Enter the bill's number, date and terms, then each line's billed quantity."
      },
      {
        "text": "A line over the receipt shows the hold; approve the rest.",
        "target": "Approve"
      },
      {
        "text": "Dispute when the whole bill is wrong.",
        "target": "Dispute"
      }
    ]
  },
  "/procurement/quotes": {
    "title": "Quotes",
    "purpose": "Vendor quotes on the job: asked, in with the amount, no answer, declined. Make the order from the one you pick.",
    "steps": [
      {
        "text": "Ask a vendor from the library: the Send sheet opens with the scope and the due date; attach the package from the job's files, then Send.",
        "target": "Ask"
      },
      {
        "text": "Mark a quote in with the amount; the lowest shows. Remind the ones still out."
      },
      {
        "text": "Make PO from the one you chose.",
        "target": "Make PO"
      }
    ]
  },
  "/procurement/plan/:kind/:id": {
    "title": "Plan a request",
    "purpose": "How each line of a field request comes: the vendor delivers, pick up at the supply house, from the shop, or the company truck. Each line starts on what the field asked (Shop or Order); you can change it and the field sees that you did. Name who carries it: the Runner picks up at the shop and the counter and brings everything to the job; a Shop person, when there is one, pulls and stages the shop lines for the runner. The order to the vendor is made after this step, never before.",
    "steps": [
      {
        "text": "Read the field's offer and each line's Shop / Order choice; they are suggestions, you decide."
      },
      {
        "text": "Pick a route per line, with a date, a branch, a driver or a shelf note as the route needs. All lines sets them at once."
      },
      {
        "text": "Runner is required when any line is from the shop or will-call. Shop is optional: name the person who pulls and stages at the shop, or leave it empty and the runner pulls their own. Each gets a push with their part and a row on Today until it is done.",
        "target": "Runner"
      },
      {
        "text": "Confirm sends the pushes and opens Make PO for the vendor lines.",
        "target": "Confirm plan"
      }
    ]
  },
  "/procurement/fulfilment": {
    "title": "Shop and deliveries",
    "purpose": "Three company settings that decide which routes exist: whether you keep stock at a shop, whether you deliver yourselves, and whether there is a pickup shelf.",
    "steps": [
      {
        "text": "Keep stock at a shop: off, and the shop route disappears."
      },
      {
        "text": "Deliver ourselves: never, when it suits, or on set days."
      },
      {
        "text": "Save; the plan screens follow it from then on.",
        "target": "Save"
      }
    ]
  },
  "/procurement/shelf": {
    "title": "The pickup shelf",
    "purpose": "Every line planned for a crew pickup at the shop, by the day, across the jobs. Staged tells the crew it is ready.",
    "steps": [
      {
        "text": "Pull the line and put it on the shelf with the tag note."
      },
      {
        "text": "Staged takes the stock off the count, logs it, and pushes the crew.",
        "target": "Staged"
      },
      {
        "text": "The foreman taps Got it when it is in the truck."
      }
    ]
  },
  "/procurement/runs": {
    "title": "Runs",
    "purpose": "The company truck's trips: a date, a driver, the stops, the lines going out and what comes back. The driver works it from the phone.",
    "steps": [
      {
        "text": "New run lists the lines planned for the truck; tick them by day and pick the driver.",
        "target": "New run"
      },
      {
        "text": "Set the run: the driver and each requester get a push."
      },
      {
        "text": "Close the run when it is back; shorts go back to planning and tool returns are checked in."
      }
    ]
  },
  "/punch": {
    "title": "Punch list",
    "purpose": "The punch grouped the way you walk it: by floor, area and room. Open, Ready and Verified counts at the top; a late due date shows in red. The GC's items show here too.",
    "steps": [
      {
        "text": "New item from a photo: take the photo, say what is wrong, floor, area, room, who fixes it, when it is due.",
        "target": "New item"
      },
      {
        "text": "Tap an item to mark it fixed, reopen it, or verify it."
      },
      {
        "text": "Closeout at the top is the end-of-job checklist, counting down to the last payment.",
        "target": "Closeout"
      }
    ]
  },
  "/punch/new": {
    "title": "New punch item",
    "purpose": "One item from a photo. Whoever it is assigned to gets a push.",
    "steps": [
      {
        "text": "Take the photo, then say what is wrong."
      },
      {
        "text": "Floor, area and room; who fixes it; when it is due."
      },
      {
        "text": "Save, add another keeps the floor and area for the next one.",
        "target": "Save, add another"
      }
    ]
  },
  "/punch/closeout": {
    "title": "Closeout",
    "purpose": "The same twelve items the office uses for the closeout package. A lead checks each one off as it is in hand; the item shows who and when.",
    "steps": [
      {
        "text": "Tap an item to check it off; add one if the job needs it."
      },
      {
        "text": "When only the pay app, lien waiver and retainage are left, the list says final payment is waiting on them."
      }
    ]
  },
  "/punch/:id": {
    "title": "A punch item",
    "purpose": "Fix it, take the after photo, mark it ready; the foreman verifies. Not right? Reopen with a reason; the reason stays on the item.",
    "steps": [
      {
        "text": "Take the after photo, then Mark fixed, ready to check.",
        "target": "Mark fixed"
      },
      {
        "text": "Foreman, super or office: Verified, close it.",
        "target": "Verified"
      },
      {
        "text": "Reopen with a reason if it is not right.",
        "target": "Reopen"
      }
    ]
  },
  "/service": {
    "title": "Service",
    "purpose": "For a tech: today's stops with directions and the contact. For the office: the calls with no tech, who is on site, what is done and waiting for its invoice, what is unpaid.",
    "steps": [
      {
        "text": "Tech: tap the stop to open the work order; Directions opens the maps app.",
        "target": "Directions"
      },
      {
        "text": "Office: Unassigned is the list to dispatch; Done · make the invoice is the list to bill today."
      },
      {
        "text": "New call takes the call in.",
        "target": "New call"
      }
    ]
  },
  "/service/new": {
    "title": "New call",
    "purpose": "The call in: the customer found by name, company or phone or added on the spot, the site, the problem, how soon, access, the work type, and the dispatch.",
    "steps": [
      {
        "text": "Type the customer; pick them, or New customer."
      },
      {
        "text": "The problem, what to bring, access. How soon: today, this week, a date."
      },
      {
        "text": "Work type: a repair is taxable; a capital improvement is exempt with the signed ST-8 kept with the job."
      },
      {
        "text": "Pick the tech, the date, the time and the hours, then Dispatch; or Save as unassigned.",
        "target": "Dispatch"
      }
    ]
  },
  "/service/wo/:id": {
    "title": "A work order",
    "purpose": "The stop on the phone: clock in here, what was found and fixed, the parts off the truck, photos, the customer's signature, Done. The office assigns and invoices from the same page.",
    "steps": [
      {
        "text": "Clock in here when you arrive; it is your punch for the day on this job.",
        "target": "Clock in here"
      },
      {
        "text": "Write what you found and did; add each part used; take the photos."
      },
      {
        "text": "Hand the customer the phone to sign.",
        "target": "Sign"
      },
      {
        "text": "Done. Clock out from the Clock page when you leave.",
        "target": "Done"
      }
    ]
  },
  "/service/wo/:id/invoice": {
    "title": "The invoice",
    "purpose": "Built from the stop: the trip charge, the labor from the clock rounded up to the quarter hour, the parts at list, the tax by the work type. Sent as a PDF; locked once sent except for Paid and Void.",
    "steps": [
      {
        "text": "Read the lines from the work order; Make the invoice.",
        "target": "Make the invoice"
      },
      {
        "text": "Fix a line or the bill-to if you must; Save."
      },
      {
        "text": "Send invoice attaches the PDF and goes from your address.",
        "target": "Send invoice"
      },
      {
        "text": "Paid when the money lands.",
        "target": "Paid"
      }
    ]
  },
  "/service/invoices": {
    "title": "Service invoices",
    "purpose": "Every service invoice: unpaid by age, paid, all. Unpaid ones over thirty days are chased by themselves on Mondays.",
    "steps": [
      {
        "text": "Tap an invoice to open its work order and invoice."
      }
    ]
  },
  "/service/customers": {
    "title": "Customers",
    "purpose": "The customer book: find anyone by name, company or phone; what is open with them.",
    "steps": [
      {
        "text": "Search, then tap the customer."
      },
      {
        "text": "New adds one; a new call can add one too.",
        "target": "New"
      }
    ]
  },
  "/service/customer/:id": {
    "title": "A customer",
    "purpose": "Contact, site, the billing block the invoice bills to, the rate, the equipment on site, notes for techs, every visit with its invoice.",
    "steps": [
      {
        "text": "Edit the contact and the billing block; the invoice reads them.",
        "target": "Edit"
      },
      {
        "text": "Add the equipment on site with a flag when something needs a quote."
      },
      {
        "text": "Notes for techs: the gate code, where the panel is."
      },
      {
        "text": "New work order starts a call for them.",
        "target": "New work order"
      }
    ]
  },
  "/service/dispatch": {
    "title": "Dispatch",
    "purpose": "The board: techs down the side, the hours across, each stop a block; the unassigned calls under it with Assign.",
    "steps": [
      {
        "text": "Assign on a call: the time, the hours, the tech. The tech's phone gets the stop.",
        "target": "Assign"
      },
      {
        "text": "Today, Tomorrow and the arrows move the day."
      }
    ]
  },
  "/service/settings": {
    "title": "Rates and tax",
    "purpose": "What a service call bills: the labor rate, the trip charge, the sales tax, whether tax lands on every line or the parts only, the terms.",
    "steps": [
      {
        "text": "Set the rates; pick where tax lands on a repair."
      },
      {
        "text": "Save. Owner or admin only.",
        "target": "Save"
      }
    ]
  },
  "/clock": {
    "title": "Clock",
    "purpose": "Clock in when you arrive and out when you leave. Every punch is stamped with the job and where the phone was; that is what protects your hours.",
    "steps": [
      {
        "text": "Pick the job you are on today.",
        "target": "job"
      },
      {
        "text": "Tap Clock in before you pick up a tool.",
        "target": "Clock in"
      },
      {
        "text": "At the end of the day tap Clock out. If the phone says a punch is waiting for signal, keep the app open a moment once you have signal; it sends itself with the time you tapped.",
        "target": "Clock out"
      },
      {
        "text": "My week shows your days, punches and hours; Fix this punch is there if you forgot one."
      }
    ]
  },
  "/time/week": {
    "title": "My week",
    "purpose": "Your week as the office sees it: each day, the job, the punches, the hours, and anything changed or flagged.",
    "steps": [
      {
        "text": "Check each day's hours. A changed or flagged punch says so."
      },
      {
        "text": "Missed a punch? Open that day and tap Fix this punch, say what the time should have been and why.",
        "target": "Fix this punch"
      },
      {
        "text": "Friday, tap Submit week. If you forget, it submits itself Friday at 8 PM.",
        "target": "Submit week"
      }
    ]
  },
  "/time/fix/:id": {
    "title": "Fix a punch",
    "purpose": "Ask for a punch to be corrected. Nobody edits a punch directly; both versions stay in the log and your foreman approves it.",
    "steps": [
      {
        "text": "Enter what the time should have been."
      },
      {
        "text": "Pick why: forgot, phone died, wrong job."
      },
      {
        "text": "Send. Your foreman gets a push and approves it.",
        "target": "Send"
      }
    ]
  },
  "/time/approve": {
    "title": "Approve the week",
    "purpose": "Foreman: the crew's weeks, with the fixes waiting on you. Approved weeks lock; the office still does payroll as before.",
    "steps": [
      {
        "text": "Decide each fix request first: Approve or Decline with a word."
      },
      {
        "text": "Approve each person, or all at once when everything is right.",
        "target": "Approve"
      }
    ]
  },
  "/schedule": {
    "title": "Schedule",
    "purpose": "Where you are each day this week. Foremen see the whole crew by person or by job and can move someone with a tap.",
    "steps": [
      {
        "text": "Your days are listed with the job and the start."
      },
      {
        "text": "Foreman: switch By person and By job; tap a day to move someone. They get a push.",
        "target": "By job"
      },
      {
        "text": "3-week look-ahead shows what is coming on the job: milestones, deliveries, inspections, meetings.",
        "target": "look-ahead"
      }
    ]
  },
  "/lookahead": {
    "title": "Look-ahead",
    "purpose": "The next three weeks on this job, your week, or every job: plan dates, deliveries, inspections and meetings with the crew count.",
    "steps": [
      {
        "text": "Switch between this job, your week and all jobs at the top."
      },
      {
        "text": "A meeting with a Teams, Meet or Zoom link shows Join; one tap joins.",
        "target": "Join"
      }
    ]
  },
  "/warehouse": {
    "title": "Warehouse",
    "purpose": "What is on the shelf and under minimum, the pulls for the trucks by day, the tool board, today's movements.",
    "steps": [
      {
        "text": "Low stock is the reorder list; tap an item to reorder."
      },
      {
        "text": "Pulls lists what the office planned from the shop, by day; open one to pull it."
      },
      {
        "text": "The tool board shows what needs attention and what is out on jobs."
      }
    ]
  },
  "/warehouse/stock": {
    "title": "Stock",
    "purpose": "Every item with its bin, on hand and minimum. Search by name, bin or barcode; scan a label to open the item.",
    "steps": [
      {
        "text": "Search or filter by category; Low shows only what is under minimum."
      },
      {
        "text": "Scan opens the item whose barcode or bin matches.",
        "target": "Scan"
      },
      {
        "text": "Item adds a new one.",
        "target": "Item"
      }
    ]
  },
  "/warehouse/item/:id": {
    "title": "A stock item",
    "purpose": "On hand, minimum, usual order and last cost; receive, ship to a job, count with a reason, reorder with one tap; the movements.",
    "steps": [
      {
        "text": "Receive what comes in with the quantity and the cost.",
        "target": "Receive"
      },
      {
        "text": "Ship to a job: the foreman confirms it on the phone. Count sets what you found, with the reason."
      },
      {
        "text": "Learn this barcode once from a scan; after that a scan opens the item."
      },
      {
        "text": "Reorder makes the purchase order on the stock job for Procurement to send.",
        "target": "Reorder"
      }
    ]
  },
  "/warehouse/pull/:pid/:kind/:id": {
    "title": "A pull",
    "purpose": "One request's shop lines as a pick list: the bin and what is on hand, short lines flagged. Pulled per line takes the stock down and tells the crew it is ready.",
    "steps": [
      {
        "text": "Pull each line and tap Pulled, or scan the item's barcode.",
        "target": "Pulled"
      },
      {
        "text": "Pick list prints the sheet for the truck.",
        "target": "Pick list"
      },
      {
        "text": "A short line stays open; tell the office."
      }
    ]
  },
  "/warehouse/tools": {
    "title": "Tools",
    "purpose": "The library by shelf, on jobs, repair and missing, grouped by job. Add a tool and it gets a tag number; scan a tag to open it.",
    "steps": [
      {
        "text": "Filter by where they are; search by name, tag, serial, job or person."
      },
      {
        "text": "Tap a tool to check it out or in, or report it."
      },
      {
        "text": "Tool adds one with its serial.",
        "target": "Tool"
      }
    ]
  },
  "/warehouse/tool/:id": {
    "title": "A tool",
    "purpose": "Who has it, on which job, since when; check out, check in, hand off, report a problem or mark it missing; the history.",
    "steps": [
      {
        "text": "Check out to a job and the person taking it; the foreman gets the push.",
        "target": "Check out"
      },
      {
        "text": "Check in when it comes back.",
        "target": "Check in"
      },
      {
        "text": "Report a problem or Missing with a note; the office gets the bell and it comes up again until it is found or written off."
      }
    ]
  },
  "/warehouse/requests": {
    "title": "Tool requests",
    "purpose": "The field's open tool requests across the jobs, fulfilled from the library: pick the free tool that fits each line and check it out to the job.",
    "steps": [
      {
        "text": "Open a request; the free tools that match each line are offered."
      },
      {
        "text": "Pick one per line and Check out; the requester's phone says it is coming.",
        "target": "Check out"
      },
      {
        "text": "Anything not in the library is bought from the request's plan in Procurement."
      }
    ]
  },
  "/warehouse/log": {
    "title": "Movement log",
    "purpose": "Every receive, ship, count, pull and removal, newest first, by kind, with who and when.",
    "steps": [
      {
        "text": "Filter by kind; tap an item to open it."
      }
    ]
  },
  "/warehouse/settings": {
    "title": "Warehouse settings",
    "purpose": "The job stock orders go on. A purchase order needs a job; pick the shop or overhead job you already use.",
    "steps": [
      {
        "text": "Pick the job and Save. Owner or admin only.",
        "target": "Save"
      }
    ]
  },
  "/": {
    "title": "Today",
    "purpose": "Your day across every open project on one screen: what is yours and when it is due, what is waiting on someone else, what needs a decision, and the alerts that came in. Nobody has to open a project to find their own work.",
    "steps": [
      {
        "text": "Yours lists the plan rows, RFIs, submittals, change orders, punch items and requests with your name on them, late first, then today, this week, later."
      },
      {
        "text": "Waiting on others is what you sent and have not heard back on: the GC, a vendor, or the office. The pill says how long."
      },
      {
        "text": "Needs a decision (office) is what came to you: material and tool requests to plan, timesheets to approve."
      },
      {
        "text": "The bell at the top holds every alert, grouped by project, unread first. Tap one and it opens the thing it is about."
      },
      {
        "text": "Open has every module you have; More on the phone has the rest and the Guide."
      }
    ]
  },
  "/modules": {
    "title": "More",
    "purpose": "Everything in the app, and the Guide: the daily procedure and the start guide, in the app, by role.",
    "steps": [
      {
        "text": "Tap a module to open it; a locked one shows what it does and who to ask."
      },
      {
        "text": "The Guide is the written way we run a day in TradeView.",
        "target": "Guide"
      }
    ]
  },
  "/settings": {
    "title": "Settings",
    "purpose": "Push notifications, the theme, the tour again, and for the office: the team and the modules.",
    "steps": [
      {
        "text": "Turn on Push notifications and tap Allow when the phone asks. Without it you get bells but no buzz.",
        "target": "Push"
      },
      {
        "text": "Show the tour again replays the first-day cards for your role.",
        "target": "Show the tour"
      }
    ]
  },
  "/guide": {
    "title": "The Guide",
    "purpose": "The daily procedure and the start guide, in the app, and the map: every module and screen you can open, what each is for, and how the pieces hand off.",
    "steps": [
      {
        "text": "Type a word to find the step you need.",
        "target": "Search"
      },
      {
        "text": "The map lists every module and screen in the app's own order; tap a screen for what it is for, its steps and a link to open it.",
        "target": "The map"
      },
      {
        "text": "Every screen also has this question mark with its own steps."
      }
    ]
  },
  "/settings/contacts": {
    "title": "Contacts",
    "purpose": "The GCs and the vendors every send picks from: company, the person, email, phone, notes; what a vendor supplies and our account. The old app's Library reads the same records.",
    "steps": [
      {
        "text": "GCs or Vendors, then search by company, person or email. A red row has no email and cannot be sent to.",
        "target": "Vendors"
      },
      {
        "text": "New adds one; tap a row to edit it. The office edits, everyone reads.",
        "target": "New"
      },
      {
        "text": "The send button on a row opens a new message to them on the job you are on."
      }
    ]
  },
  "/settings/followups": {
    "title": "Follow-ups",
    "purpose": "Every schedule the app runs by itself, in one place: GC follow-ups on bids, RFIs, submittals and change orders; vendor quote reminders; the application and service invoice chases; the bid due-soon bell; the tool sweeps; the send hour.",
    "steps": [
      {
        "text": "Days are counted from the date the thing went out, comma separated for several steps."
      },
      {
        "text": "Save; the schedules read it from the next run.",
        "target": "Save"
      }
    ]
  },
  "/alerts": {
    "title": "Alerts",
    "purpose": "Everything TradeView told you, grouped by project with the unread first: assignments, things sent and answered, approvals, anything running late. The same alerts reach your phone as pushes when they are on.",
    "steps": [
      {
        "text": "Tap an alert to open the record it is about; it is marked read as you go."
      },
      {
        "text": "Mark all read clears the badge when you have caught up."
      },
      {
        "text": "Pushes to the phone are turned on in Settings; the bell works either way."
      }
    ]
  },
  "/settings/company": {
    "title": "Company",
    "purpose": "Who you are on every document that leaves the app: name, address, phone, email and licence in the header, the logo and accent colour, who signs, and the standard clarifications, exclusions, terms and unit prices a new proposal starts with.",
    "steps": [
      {
        "text": "Upload the logo as a PNG on white; it prints at the top of the proposal.",
        "target": "Upload logo"
      },
      {
        "text": "One line per clarification or exclusion. A new proposal copies them in; the office edits them per bid without touching these."
      },
      {
        "text": "Save. Proposals already written keep their own text.",
        "target": "Save company"
      }
    ]
  }
};
